const TIPO_NAVEGACAO_PERFIL = {
  USUARIO: 'usuario',
  ANALISTA: 'analista',
};

export default TIPO_NAVEGACAO_PERFIL;
